export const tickerItems = [
  { id: "t1", text: "《龙渊纪年》第 214 话 · 决战前夜已更新", time: "2 小时前" },
  { id: "t2", text: "《雾都夜行录》第 87 话 · 雨夜的第 13 封来信", time: "5 小时前" },
  { id: "t3", text: "《我在武道尽头等你》第 156 话 · 少年剑成", time: "今天 09:20" },
  { id: "t4", text: "《天穹之下的约定》第 43 话 · 毕业前的天台", time: "今天 08:00" },
  { id: "t5", text: "完结全集上新：《万象机关城》全 165 话打包", time: "昨天 23:10" },
  { id: "t6", text: "《机甲纪元：破晓》第 121 话 · 血月升空", time: "昨天 22:40" },
  { id: "t7", text: "完结全集上新：《深海来信》全 72 话治愈直通车", time: "昨天 21:05" },
  { id: "t8", text: "《山海食堂》第 68 话 · 深夜的一碗蟹粉面", time: "昨天 20:15" },
];

export interface ComicItem {
  id: string;
  title: string;
  author: string;
  genre: string;
  status: "连载中" | "已完结";
  progress: string;
  updatedAt: string;
  summary: string;
  tags: string[];
  heat: string;
  cover: string;
}

export const latestUpdates: ComicItem[] = [
  {
    id: "c1",
    title: "龙渊纪年",
    author: "白泽工作室",
    genre: "玄幻",
    status: "连载中",
    progress: "更新至 214 话",
    updatedAt: "2 小时前",
    summary:
      "少年自寒潭醒来，肩头刻着一枚龙纹。他要在三大龙裔的赌局里，找回被抹去的十年记忆，也找回那座沉入深渊的旧城。",
    tags: ["东方玄幻", "热血", "双男主"],
    heat: "128.6 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20graphic%20novel%20cover%20illustration%20of%20an%20ancient%20eastern%20dragon%20coiled%20around%20a%20snow%20mountain%20peak%20with%20red%20banners%2C%20bold%20flat%20shapes%2C%20dramatic%20warm%20red%20and%20gold%20limited%20palette%2C%20textured%20paper%20grain%2C%20abstract%20painterly%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-01&orientation=portrait",
  },
  {
    id: "c2",
    title: "雾都夜行录",
    author: "沈砚",
    genre: "悬疑",
    status: "连载中",
    progress: "更新至 87 话",
    updatedAt: "5 小时前",
    summary:
      "雾气每晚十一点涌入旧城区，之后发生的事没有人记得。侦探程野是唯一能在雾里保持清醒的人，也是唯一被怀疑的人。",
    tags: ["都市悬疑", "推理", "单元剧"],
    heat: "96.2 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20mystery%20comic%20cover%20illustration%20of%20a%20lone%20figure%20in%20a%20trench%20coat%20standing%20under%20a%20flickering%20street%20lamp%20in%20thick%20night%20fog%2C%20silhouette%20style%2C%20muted%20green%20and%20amber%20limited%20palette%2C%20grainy%20texture%2C%20abstract%20city%20shapes%20in%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-02&orientation=portrait",
  },
  {
    id: "c3",
    title: "我在武道尽头等你",
    author: "拾柒漫画社",
    genre: "热血",
    status: "连载中",
    progress: "更新至 156 话",
    updatedAt: "今天 09:20",
    summary:
      "他没有天生的武脉，只靠一本被战火熏黑的旧笔记。从县城擂台到天下武会，他把每一次出场都变成了别人的传说。",
    tags: ["少年热血", "成长", "擂台"],
    heat: "112.4 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20action%20comic%20cover%20illustration%20of%20a%20young%20martial%20artist%20mid%20punch%20with%20flowing%20energy%20trails%2C%20dynamic%20diagonal%20composition%2C%20bold%20red%20orange%20and%20cream%20limited%20palette%2C%20speed%20lines%2C%20paper%20grain%20texture%2C%20abstract%20dojo%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-03&orientation=portrait",
  },
  {
    id: "c4",
    title: "天穹之下的约定",
    author: "柚子酱",
    genre: "恋爱",
    status: "连载中",
    progress: "更新至 43 话",
    updatedAt: "今天 08:00",
    summary:
      "天文社的两个人约定：只要还能看见同一片星空，就算毕业也不说再见。可那年夏天，城市的灯把星星一盏盏熄掉了。",
    tags: ["校园恋爱", "治愈", "群像"],
    heat: "88.9 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20romance%20comic%20cover%20illustration%20of%20two%20students%20standing%20on%20a%20school%20rooftop%20under%20a%20vast%20star%20filled%20sky%2C%20soft%20warm%20peach%20and%20amber%20limited%20palette%2C%20flat%20shapes%2C%20delicate%20paper%20texture%2C%20dreamy%20abstract%20cloud%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-04&orientation=portrait",
  },
  {
    id: "c5",
    title: "机甲纪元：破晓",
    author: "铁翎原创",
    genre: "科幻",
    status: "连载中",
    progress: "更新至 121 话",
    updatedAt: "昨天 22:40",
    summary:
      "当最后一台量产机甲退役，废铁场里的技师少年把它重新点亮。血月升空那晚，整座城市听见了它的第一次心跳。",
    tags: ["科幻机甲", "末世", "工业风"],
    heat: "104.7 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20sci%20fi%20mecha%20comic%20cover%20illustration%20of%20a%20towering%20rusty%20humanoid%20robot%20standing%20in%20a%20scrapyard%20at%20dusk%2C%20bold%20industrial%20silhouette%2C%20limited%20terracotta%20and%20steel%20palette%2C%20grainy%20texture%2C%20abstract%20geometric%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-05&orientation=portrait",
  },
  {
    id: "c6",
    title: "山海食堂",
    author: "陆阿姨的小店",
    genre: "美食",
    status: "连载中",
    progress: "更新至 68 话",
    updatedAt: "昨天 20:15",
    summary:
      "一家只在深夜开门的小食堂，客人都是些说不清来处的老朋友。每一话一道家常菜，每一道菜藏着一个没能说出口的故事。",
    tags: ["美食日常", "治愈", "短篇"],
    heat: "73.5 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20cozy%20food%20comic%20cover%20illustration%20of%20a%20small%20late%20night%20noodle%20shop%20with%20steaming%20bowls%20and%20warm%20hanging%20lanterns%2C%20flat%20shapes%2C%20warm%20amber%20and%20cream%20limited%20palette%2C%20soft%20paper%20texture%2C%20abstract%20wooden%20interior%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-06&orientation=portrait",
  },
  {
    id: "c7",
    title: "星海拾荒者",
    author: "引力波",
    genre: "科幻",
    status: "连载中",
    progress: "更新至 99 话",
    updatedAt: "昨天 18:30",
    summary:
      "在废弃航道的碎片带里讨生活的人都叫他老拾。直到他从一艘无人舰里捡回一个会哭的导航仪，全星系都开始追他。",
    tags: ["太空冒险", "公路片", "幽默"],
    heat: "81.3 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20space%20adventure%20comic%20cover%20illustration%20of%20a%20lone%20salvager%20floating%20among%20colorful%20junk%20debris%20near%20a%20giant%20planet%20ring%2C%20bold%20flat%20shapes%2C%20warm%20coral%20and%20violet%20free%20limited%20palette%2C%20grainy%20texture%2C%20abstract%20cosmos%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-07&orientation=portrait",
  },
  {
    id: "c8",
    title: "青云剑歌",
    author: "半山砚",
    genre: "仙侠",
    status: "连载中",
    progress: "更新至 302 话",
    updatedAt: "昨天 15:00",
    summary:
      "师门覆灭那夜，他把名字还给了山，只带走一把断剑。三百年后，青云之上多了一位不愿称仙的剑客。",
    tags: ["古典仙侠", "复仇", "长篇"],
    heat: "119.8 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20xianxia%20comic%20cover%20illustration%20of%20a%20swordsman%20in%20flowing%20robes%20standing%20on%20cloud%20shrouded%20peaks%20holding%20a%20broken%20sword%2C%20elegant%20ink%20style%20with%20flat%20shapes%2C%20jade%20green%20and%20gold%20limited%20palette%2C%20paper%20texture%2C%20abstract%20misty%20mountain%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-08&orientation=portrait",
  },
  {
    id: "c9",
    title: "末班地铁的怪谈",
    author: "夜行科",
    genre: "灵异",
    status: "连载中",
    progress: "更新至 27 话",
    updatedAt: "昨天 12:10",
    summary:
      "每天 23:58，三号线会多开一班不报站的车。上车的人都说，它只停靠一个你没有去过、却觉得熟悉的地方。",
    tags: ["都市怪谈", "短篇", "惊悚"],
    heat: "67.4 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20horror%20comic%20cover%20illustration%20of%20an%20empty%20old%20subway%20car%20interior%20with%20flickering%20fluorescent%20lights%20and%20a%20distant%20shadowy%20figure%2C%20bold%20flat%20shapes%2C%20desaturated%20teal%20and%20amber%20limited%20palette%2C%20grainy%20texture%2C%20abstract%20tunnel%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-latest-09&orientation=portrait",
  },
];

export const completedComics: ComicItem[] = [
  {
    id: "f1",
    title: "重生之都市符师",
    author: "一纸山河",
    genre: "都市",
    status: "已完结",
    progress: "全 520 话",
    updatedAt: "已完结",
    summary:
      "符文师陈默带着上一世的记忆回到大学报到的那个雨天。这一世，他要把欠下的人情一个个还清，把走散的路线重新画对。",
    tags: ["都市异能", "爽文", "长篇"],
    heat: "203.1 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20urban%20fantasy%20comic%20cover%20illustration%20of%20a%20young%20man%20in%20a%20rainy%20city%20street%20surrounded%20by%20glowing%20floating%20calligraphy%20runes%2C%20bold%20flat%20shapes%2C%20warm%20red%20and%20ink%20black%20limited%20palette%2C%20grainy%20texture%2C%20abstract%20skyline%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-done-01&orientation=portrait",
  },
  {
    id: "f2",
    title: "星轨之下",
    author: "林深见鹿",
    genre: "科幻",
    status: "已完结",
    progress: "全 240 话",
    updatedAt: "已完结",
    summary:
      "在环形空间站长大的女孩第一次回到地面，却发现脚下这颗星球正沿着一条被计算好的星轨，缓慢地离开太阳。",
    tags: ["软科幻", "成长", "完结佳作"],
    heat: "76.8 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20sci%20fi%20comic%20cover%20illustration%20of%20a%20girl%20looking%20up%20at%20a%20giant%20glowing%20orbit%20ring%20encircling%20a%20small%20planet%2C%20bold%20flat%20shapes%2C%20limited%20amber%20and%20deep%20teal%20palette%2C%20soft%20grain%2C%20abstract%20star%20field%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-done-02&orientation=portrait",
  },
  {
    id: "f3",
    title: "校园奇谈：十三号教室",
    author: "旧钟楼",
    genre: "悬疑",
    status: "已完结",
    progress: "全 96 话",
    updatedAt: "已完结",
    summary:
      "旧教学楼没有十三号教室，可每年转学来的第十三个人，都会被分到那里。这届的第十三人，决定把点名册翻到最后一页。",
    tags: ["校园悬疑", "解谜", "中篇"],
    heat: "69.2 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20mystery%20comic%20cover%20illustration%20of%20a%20dim%20empty%20classroom%20at%20night%20with%20rows%20of%20desks%20and%20chalk%20dust%20in%20the%20air%2C%20bold%20flat%20shapes%2C%20muted%20green%20and%20orange%20limited%20palette%2C%20grainy%20texture%2C%20abstract%20window%20light%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-done-03&orientation=portrait",
  },
  {
    id: "f4",
    title: "北境长歌",
    author: "长风渡",
    genre: "古风",
    status: "已完结",
    progress: "全 388 话",
    updatedAt: "已完结",
    summary:
      "边关的守将换成了一位不会打仗的年轻书生。他带着一册没写完的边塞诗，陪着一座孤城，等来了那场迟到的春天。",
    tags: ["历史向", "战争", "群像"],
    heat: "91.5 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20historical%20epic%20comic%20cover%20illustration%20of%20a%20lone%20fortress%20city%20wall%20under%20snow%20with%20tattered%20banners%20and%20a%20tiny%20scholar%20figure%2C%20bold%20flat%20shapes%2C%20muted%20ochre%20and%20slate%20limited%20palette%2C%20paper%20grain%20texture%2C%20abstract%20mountain%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-done-04&orientation=portrait",
  },
  {
    id: "f5",
    title: "深海来信",
    author: "鲸落之后",
    genre: "治愈",
    status: "已完结",
    progress: "全 72 话",
    updatedAt: "已完结",
    summary:
      "海边邮局只剩一位老邮差，每天替人寄出那些不会有人收到的信。直到某个清晨，他收到一封盖着深海邮戳的回信。",
    tags: ["文艺治愈", "短篇", "完结佳作"],
    heat: "58.4 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20gentle%20comic%20cover%20illustration%20of%20a%20small%20seaside%20post%20office%20by%20a%20calm%20sea%20at%20dawn%20with%20a%20single%20letter%20floating%20in%20water%2C%20soft%20flat%20shapes%2C%20warm%20peach%20and%20sea%20green%20limited%20palette%2C%20delicate%20texture%2C%20abstract%20horizon%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-done-05&orientation=portrait",
  },
  {
    id: "f6",
    title: "万象机关城",
    author: "齿轮与书",
    genre: "幻想",
    status: "已完结",
    progress: "全 165 话",
    updatedAt: "已完结",
    summary:
      "这座会自己改道的城市靠一万枚齿轮运转，也靠一份不断被涂改的地图活着。修表匠的女儿接过了那份地图，也接下了它的秘密。",
    tags: ["蒸汽幻想", "冒险", "完结佳作"],
    heat: "84.0 万",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20steampunk%20fantasy%20comic%20cover%20illustration%20of%20a%20towering%20mechanical%20city%20built%20from%20giant%20interlocking%20gears%20and%20brass%20towers%2C%20bold%20flat%20shapes%2C%20warm%20copper%20and%20ink%20limited%20palette%2C%20grainy%20texture%2C%20abstract%20sky%20background%2C%20no%20text%2C%20vertical%20portrait%20composition&width=400&height=560&seq=xx-done-06&orientation=portrait",
  },
];

export const rankList = [
  { rank: 1, title: "龙渊纪年", genre: "玄幻", note: "本周新增 214 话讨论", heat: 128.6 },
  { rank: 2, title: "青云剑歌", genre: "仙侠", note: "连载 302 话 稳居前列", heat: 119.8 },
  { rank: 3, title: "我在武道尽头等你", genre: "热血", note: "擂台篇完结在即", heat: 112.4 },
  { rank: 4, title: "机甲纪元：破晓", genre: "科幻", note: "血月篇新章开更", heat: 104.7 },
  { rank: 5, title: "雾都夜行录", genre: "悬疑", note: "单元剧口碑走高", heat: 96.2 },
  { rank: 6, title: "北境长歌", genre: "古风", note: "完结后仍持续被回看", heat: 91.5 },
  { rank: 7, title: "天穹之下的约定", genre: "恋爱", note: "校园线进入主线", heat: 88.9 },
  { rank: 8, title: "万象机关城", genre: "幻想", note: "全集下载量上升", heat: 84.0 },
  { rank: 9, title: "星海拾荒者", genre: "科幻", note: "公路片单元连载中", heat: 81.3 },
  { rank: 10, title: "深海来信", genre: "治愈", note: "短篇完结一口气看完", heat: 58.4 },
];

export const genres = [
  { name: "玄幻", icon: "ri-magic-line", count: 482, desc: "东方修真与架空世界" },
  { name: "都市", icon: "ri-building-2-line", count: 511, desc: "现代背景与异能日常" },
  { name: "热血", icon: "ri-fire-line", count: 396, desc: "少年成长与擂台对决" },
  { name: "恋爱", icon: "ri-heart-3-line", count: 428, desc: "校园恋爱与治愈关系" },
  { name: "科幻", icon: "ri-robot-2-line", count: 274, desc: "机甲太空与未来设定" },
  { name: "悬疑", icon: "ri-search-eye-line", count: 231, desc: "推理怪谈与解谜单元" },
  { name: "仙侠", icon: "ri-moon-clear-line", count: 305, desc: "古典仙侠与剑修江湖" },
  { name: "美食", icon: "ri-restaurant-2-line", count: 143, desc: "深夜食堂与家常短篇" },
  { name: "灵异", icon: "ri-ghost-2-line", count: 168, desc: "都市怪谈与惊悚短篇" },
  { name: "校园", icon: "ri-graduation-cap-line", count: 259, desc: "青春校园与社团群像" },
  { name: "古风", icon: "ri-quill-pen-line", count: 312, desc: "历史向与边塞长歌" },
  { name: "冒险", icon: "ri-compass-3-line", count: 287, desc: "探索旅行与机关幻想" },
];

export const readingSteps = [
  {
    step: "01",
    icon: "ri-filter-3-line",
    title: "先按口味挑",
    desc: "用题材标签或状态筛选，把「连载中」和「已完结」分开看，一眼锁定今天想追的方向。",
  },
  {
    step: "02",
    icon: "ri-book-open-line",
    title: "在线免费阅读",
    desc: "打开作品即可从第一话顺着往下看，章节顺序与更新进度一致，不用来回翻找。",
  },
  {
    step: "03",
    icon: "ri-download-2-line",
    title: "全集打包下载",
    desc: "完结作品提供全集资源入口，一次打包带走整部作品，离线也能接着读。",
  },
  {
    step: "04",
    icon: "ri-calendar-check-line",
    title: "追更新不掉队",
    desc: "更新速递条按时间排列最新话，看到感兴趣的条目可直接定位到对应作品。",
  },
];

export const faqs = [
  {
    q: "本站的漫画真的可以免费阅读吗？",
    a: "是的。本页展示的连载与完结作品均提供免费的在线阅读入口，按话数顺序阅读即可。若某部作品在版权方要求下调整了可读范围，页面上会同步标注，以实际可观看话数为准。",
  },
  {
    q: "怎么用「状态筛选」快速找到完结作品？",
    a: "在「最新更新」分区上方的筛选栏里，把状态切到「已完结」，列表就会只保留已经完结的作品；如果想看还在连载的，切到「连载中」即可。筛选只作用于本页已有的作品。",
  },
  {
    q: "完结作品的全集打包是怎么用的？",
    a: "在「完结专区」里，每部完结作品都会标注总话数，并提供「全集打包」入口。打包指的是把这部作品的完整话数整理在一起，方便一次读完或离线保存，而不是逐话点开。",
  },
  {
    q: "更新大概多久一次？",
    a: "不同作品节奏不一样，通常稳定连载的作品会保持每周固定的更新频率，热门长篇在剧情关键节点可能会加更。页面上每条更新都标了相对时间，方便判断新鲜度。",
  },
  {
    q: "手机上浏览密集的内容会不会很挤？",
    a: "不会。页面在手机上是单列排列，作品卡片会自动切换成更适合小屏的横向布局，筛选栏和标签可以横向滑动，正文与章节目录都保证在手机上清晰可读。",
  },
  {
    q: "找不到想看的作品怎么办？",
    a: "可以先用筛选栏里的关键词搜索，在本页已收录的作品标题与题材中查找；如果确实没有，说明它暂时还没有加入本站的整理范围，后续更新时会陆续补充。",
  },
];

export const editorPicks = [
  {
    no: "01",
    title: "深海来信",
    genre: "治愈 · 已完结",
    readTime: "全 72 话 · 约 4 小时读完",
    reason:
      "短篇完结，画风克制、留白多。适合下班后一次读完，也适合第 N 次回看。全篇围绕「不会被寄到的信」展开，每一话都能独立成立。",
    suitable: "适合：喜欢安静叙事、不想追更的读者",
  },
  {
    no: "02",
    title: "雾都夜行录",
    genre: "悬疑 · 连载中",
    readTime: "更新至 87 话 · 单元剧可跳读",
    reason:
      "以城市怪谈为骨架的单元式悬疑，每一话解一个谜，同时缓慢推进主线。即使中途入场也不会看不懂，适合碎片时间阅读。",
    suitable: "适合：喜欢推理、能接受慢热的读者",
  },
  {
    no: "03",
    title: "北境长歌",
    genre: "古风 · 已完结",
    readTime: "全 388 话 · 适合周末追",
    reason:
      "历史向群像长篇，战争线与人物线并行。完结后仍持续被回看，是因为它对「守城」这条主线的处理足够耐心，而不是靠反转取胜。",
    suitable: "适合：偏爱史诗叙事与群像刻画的读者",
  },
];

export const heroStats = [
  { label: "收录作品", value: "3,860+", icon: "ri-book-2-line" },
  { label: "今日更新", value: "128 话", icon: "ri-flashlight-line" },
  { label: "完结全集", value: "1,240 部", icon: "ri-checkbox-circle-line" },
  { label: "在线读者", value: "42.7 万", icon: "ri-group-line" },
];

export const quickEntries = [
  { label: "看最新更新", icon: "ri-flashlight-line", target: "latest" },
  { label: "完结全集下载", icon: "ri-download-2-line", target: "completed" },
  { label: "本周人气榜", icon: "ri-bar-chart-2-line", target: "rank" },
  { label: "题材分类", icon: "ri-apps-2-line", target: "genres" },
];

export const navLinks = [
  { label: "最新更新", target: "latest" },
  { label: "完结专区", target: "completed" },
  { label: "人气榜", target: "rank" },
  { label: "题材分类", target: "genres" },
  { label: "阅读指南", target: "guide" },
  { label: "常见问题", target: "faq" },
];